<mat-form-field [floatLabel]="floatLabel" [class]="cssClass">
  <mat-label *ngIf="label">
    <span>{{ label }}</span>
    @if (showRequiredStatusInLabel) {
    <span *ngIf="required">({{ 'required' | translate }})</span>
    <span *ngIf="!required">({{ 'optional' | translate }})</span>
    }
  </mat-label>
  <input matInput type="text" placeholder="{{placeHolder}}" [formControl]="autoCompleteControl" [matAutocomplete]="auto"
    [id]="inputId" [errorStateMatcher]="errorStateMatcher" (input)="onTextChange($event)">
  <mat-autocomplete class="custom-autocomplete" #auto="matAutocomplete" [displayWith]="displayFn.bind(this)"
    (opened)="onAutocompleteOpened()" (closed)="onAutocompleteClosed()"
    (optionSelected)="onOptionSelected($event.option.value)">
    @for (option of filteredOptions | async; track option[valueProperty]) {
    <mat-option class="mat-select-actions" [value]="option">
      @if (metaAsSubtitle) {
      <span class="auto-complete-option--stacked">
        <span>{{option[textProperty]}}</span>
        <small *ngIf="option[additionalTextProperty]">{{option[additionalTextProperty]}}</small>
      </span>
      } @else {
      {{option[textProperty]}}
      <span *ngIf="textSeparator && option[additionalTextProperty]">{{textSeparator}}</span>
      <span *ngIf="additionalTextProperty">{{option[additionalTextProperty]}}</span>
      }
      <div class="mat-select-actions__buttons opacity-1" *ngIf="enableAddAction && noOptions">
        <button type="button" id="btn_createNewAutoCompleteOption" mat-stroked-button color="primary" class="opacity-1">
          {{ 'autoComplete.create' | translate }}
        </button>
      </div>
      <div class="mat-select-actions__buttons"
        *ngIf="(showActionsButtons || showEditButtons || showDeleteButtons) && !noOptions">
        <button type="button" id="btn_deleteAutoCompleteOption" mat-icon-button (click)="onDeleteOption(option)"
          *ngIf="showActionsButtons || showDeleteButtons">
          <icon name="delete"></icon>
        </button>
        <button type="button" id="btn_editAutoCompleteOption" mat-icon-button (click)="onEditOption(option)"
          *ngIf="showActionsButtons || showEditButtons">
          <icon name="edit"></icon>
        </button>
      </div>
    </mat-option>
    }
    <mat-option *ngIf="enablePinnedCreateNewOption && !noOptions" class="mat-select-actions" (click)="onCreateNewClicked()">
      <button type="button" id="btn_createNewAutoCompleteOption" mat-button color="primary" style="padding-left: 0;"
        class="create-new-option">
        <icon name="add_circle" class="p-1"></icon>
        <span>{{ 'autoComplete.createNew' | translate }}</span>
      </button>
    </mat-option>
  </mat-autocomplete>
  <div matSuffix class="d-flex">
    <button type="button" id="btn_clearAutoComplete" mat-icon-button (click)="onClear($event)"
      *ngIf="autoCompleteControl.value && !disabled">
      <icon name="close" class="font-semibold"></icon>
    </button>
    <icon name="info" matTooltip="{{ infoText }}" matTooltipPosition="above" *ngIf="infoText">
    </icon>
    <mat-spinner id="spinner_autoComplete" diameter="25" *ngIf="selectedOptionsLoading"></mat-spinner>
  </div>
  <mat-hint id="input_hint" class="text-gray" *ngIf="hint">{{hint}}</mat-hint>
  <mat-error [id]="matErrorId" *ngIf="formSubmitted && autoCompleteControl.errors?.['required'] && requiredText">
    {{ requiredText }}
  </mat-error>
</mat-form-field>